import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ProjectWithClientInfo } from '../../../commonTypes/acs/project.types';
import { useContainer } from '../../useContainer';
import { dispatch, RootState } from '../../../store';
import { setProjects as setProjectsRedux } from '../../../store/slices/projects.slice';
import { useTranslation } from '../../useTranslation';
import { useSelector } from 'react-redux';
import { ProjectStatus } from '@cyberlabrs/helpers';
import { isNotPrivileged } from '../../../api/utils/roleUtils';

const useHttpGetAllProjectsOnMount = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [projects, setProjects] = useState<ProjectWithClientInfo[]>([]);
    const roleName = useSelector((state: RootState) => state.auth.value.role.name);

    useEffect(() => {
        const { exec, abort } = projectApi.getAllFromOrganization({
            onSuccess: res => {
                let filteredProjects = res.body;

                if (isNotPrivileged(roleName)) filteredProjects = res.body.filter(project => project.projectStatus !== ProjectStatus.COMPLETED);

                setProjects(filteredProjects);
                dispatch(setProjectsRedux(filteredProjects));
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);

    return { isReady, projects, setProjects };
};

export default useHttpGetAllProjectsOnMount;
